import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  background: #ffffff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  border-radius: 4px;
  height: 50%;
`;

export const Title = styled.text`
  font-weight: 900;
  font-family: "Roboto Slab";
  font-size: 22px;
  line-height: 29.01px;
  color: #f8f8f8;
`;

export const Subtitle = styled.text`
  font-weight: 700;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 17px;
  color: #f8f8f8;
  margin-top: 6px;
`;

export const InfoTitle = styled.text`
  font-weight: 700;
  font-family: "Roboto Slab";
  font-size: 14px;
  line-height: 17px;
  color: #1f1f1f;
  text-align: left;
`;

export const InfoSubtitle = styled.text`
  font-weight: 400;
  font-family: "Open Sans";
  font-size: 14px;
  line-height: 17px;
  color: #1f1f1f;
  margin-top: 6px;
  text-align: left;
`;

export const NonAuthHeader = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  padding: 30px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.25);
  background: #1f1f1f;
`;
export const NonAuthBody = styled.div`
  display: flex;
  flex-direction: column;
  padding: 30px;
  @media (max-width: 660px) {
    flex-direction: column;
  }
`;
export const NonAuthBodyElement = styled.div`
  display: flex;
  flex-direction: row;
  text-align: center;
  align-items: center;
  margin-bottom: 20px;
  @media (max-width: 660px) {
    flex-direction: row;
  }
`;
export const NonAuthBodyElementText = styled.div`
  display: flex;
  flex-direction: column;
  text-align: center;
  align-items: flex-start;
`;
export const NonAuthBodyElementIcon = styled.img`
  width: 35px;
  height: 35px;
  margin-bottom: 1rem;
  margin-right: 1rem;
`;
export const NonAuthFooter = styled.div`
  border-radius: ${(props) => props.theme.radius};
  text-align: center;

  button {
    width: 80%;
    margin-bottom: 1rem;
  }
`;

export const Anchor = styled.a`
  font-family: "Montserrat";
  color: #72e85f;
  font-weight: 800;
  text-decoration: none;

  &:hover {
    color: #72e85f;
  }
`;
